import useSWR from 'swr';
import { TableStats } from '@/lib/types/TableStats';
export const useTableStatistics = (datasetId: string, tableId: string) => {
  return useSWR<TableStats | null>(`/api/dataset/${datasetId}/table/${tableId}/table-stats`);
};